import { TopActionsContainer } from './TopActions.styles';
import { Grid, useTheme } from '../../../base-components';
import { Control } from 'react-hook-form';
import { IFilterOption, IBulkAction, ITableState, ITableToggle } from '../../table.interfaces';
import { ITableForm } from '../../../../common/interfaces/table.interface';
import { BottomActions, TopRightActions, TopLeftActions } from './components';

interface ITopActionsProps {
    control: Control<ITableForm>;
    filters: Array<IFilterOption>;
    bulkActions?: Array<IBulkAction>;
    toggles?: Array<ITableToggle>;
    tableState?: ITableState;
    isSticky?: boolean;
    height?: number;
}

const TopActions = (props: ITopActionsProps) => {
    const { isSticky = false, height, filters, control, bulkActions = [], toggles = [], tableState } = props;
    const theme = useTheme();

    return (
        <TopActionsContainer isSticky={isSticky} height={height}>
            <Grid
                justifyContent="space-between"
                display="flex"
                sx={{
                    paddingBottom: theme.spacing(2),
                    paddingTop: theme.spacing(1),
                }}
            >
                <Grid display="flex" alignItems="center">
                    <TopLeftActions filters={filters} />
                </Grid>
                <Grid>
                    <TopRightActions />
                </Grid>
            </Grid>
            <Grid
                item
                xs={12}
                sx={{
                    borderTop: '1px solid',
                    borderColor: theme.palette.grey[300],
                }}
            >
                <BottomActions bulkActions={bulkActions} tableState={tableState} toggles={toggles} />
            </Grid>
        </TopActionsContainer>
    );
};

export default TopActions;
